import React, { FunctionComponent } from 'react';

import styled from 'styled-components';
import { motion, MotionProps } from 'framer-motion';

interface InfoIconProps extends MotionProps {
  className?: string;
}

const InfoIcon: FunctionComponent<InfoIconProps> = ({
  className,
  variants,
}) => {
  return (
    <svg className={className || ''} viewBox="0 0 8 18">
      <Path
        variants={variants}
        d="m4,6c1.66,0,3-1.34,3-3S5.66,0,4,0,1,1.34,1,3s1.34,3,3,3Z"
      />
      <Path d="m7.12,15.59c-.48,0-.88-.39-.88-.9v-6.8c0-.49-.39-.9-.88-.9H.88c-.48,0-.88.39-.88.9v.6c0,.49.39.9.88.9s.88.39.88.9v4.42c0,.49-.39.9-.88.9s-.88.39-.88.9v.6c0,.49.39.9.88.9h6.25c.48,0,.88-.39.88-.9v-.6c0-.49-.39-.9-.88-.9h0Z" />
    </svg>
  );
};

export default styled(InfoIcon)`
  overflow: visible;
`;

const Path = styled(motion.path)`
  fill: ${({ theme }) => theme.colors.upload};
  fill-rule: evenodd;
`;
